// Customer Management API Service
import { multiFranchiseAxios } from '../axios/multiFranchiseAxios';
import {
  ICustomer,
  ICustomerCreateRequest,
  ICustomerUpdateRequest,
  ICustomerQueryParams,
  ICustomerResponse
} from '../../compiler/customer.interface';

// Base URL for Customer API
const CUSTOMER_BASE_URL = '/procurement/customer';

// Get all customers with pagination and filtering
export const APIGetCustomers = async (params?: ICustomerQueryParams): Promise<ICustomerResponse> => {
  try {
    const response = await multiFranchiseAxios.get(CUSTOMER_BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

// Get customer by UUID
export const APIGetCustomerById = async (uuid: string): Promise<ICustomer> => {
  try {
    const response = await multiFranchiseAxios.get(`${CUSTOMER_BASE_URL}/${uuid}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer by ID:', error);
    throw error;
  }
};

// Get customer by customer code
export const APIGetCustomerByCode = async (customerCode: string): Promise<ICustomer> => {
  try {
    const response = await multiFranchiseAxios.get(`${CUSTOMER_BASE_URL}/by-code/${customerCode}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer by code:', error);
    throw error;
  }
};

// Get customers by franchise UUID
export const APIGetCustomersByFranchise = async (franchiseUuid: string): Promise<ICustomer[]> => {
  try {
    const response = await multiFranchiseAxios.get(`${CUSTOMER_BASE_URL}/by-franchise/${franchiseUuid}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customers by franchise:', error);
    throw error;
  }
};

// Create new customer
export const APICreateCustomer = async (data: ICustomerCreateRequest): Promise<ICustomer> => {
  try {
    const response = await multiFranchiseAxios.post(CUSTOMER_BASE_URL, data);
    return response.data;
  } catch (error) {
    console.error('Error creating customer:', error);
    throw error;
  }
};

// Update customer
export const APIUpdateCustomer = async (uuid: string, data: ICustomerUpdateRequest): Promise<ICustomer> => {
  try {
    const response = await multiFranchiseAxios.patch(`${CUSTOMER_BASE_URL}/${uuid}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating customer:', error);
    throw error;
  }
};

// Delete customer (soft delete)
export const APIDeleteCustomer = async (uuid: string): Promise<void> => {
  try {
    await multiFranchiseAxios.delete(`${CUSTOMER_BASE_URL}/${uuid}`);
  } catch (error) {
    console.error('Error deleting customer:', error);
    throw error;
  }
};